import React from 'react'
import Img from 'gatsby-image'

class ServicePlanSummary extends React.Component {
    render() {
        const plan = this.props.plan;
        const imageSizes = this.props.imageSizes;
        let features = '';

        if (this.props.showFeatures) {
            features = (
                <div className="plan-features">
                    <h4>
                        Features:
                    </h4>
                    <ul>
                    {plan.features.map(feature => {
                        return <li>{feature}</li>
                    })}
                    </ul>
                </div>
            )
        }
        return (
            <div className="col-4">
                <span className="image fit">
                    <Img
                        className=""
                        sizes={imageSizes[plan.imageKey].sizes}
                        alt="EMS Home Services, HVAC Services, Austin TX"
                    />
                </span>
                <h3>{plan.name}</h3>
                <div className="plan-cost">
                    <span>${plan.costMonth} / month</span><br/>
                    <span>${plan.costYear} / year</span>
                </div>
                <br/>
                {features}
                <p>
                    {plan.description}
                </p>
                {/* <ul className="actions">
                    <li><a href="#" className="button">More</a></li>
                </ul> */}
            </div>
        );
    }
}

export default ServicePlanSummary




// WEBPACK FOOTER //
// ./src/components/ServicePlanSummary.js